module.exports = __webpack_public_path__ + "img/synreceptors.370073e1.png";